import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=88c9d284&"
import script from "./JsonEditor.vue?vue&type=script&lang=ts&"
export * from "./JsonEditor.vue?vue&type=script&lang=ts&"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports